import { useBuildingHistoryQuery, useBuildingQuery } from '@common/cache';
import { useContext, useEffect, useState } from 'react';
import { AdminPanelDrawerContext } from '@views/pages/Admin/context';

interface IUseBuildingItemProps {
  id: string;
  handleClose: () => void;
}

const historyTabIndex = '3';

export const useBuildingItem = ({ id, handleClose }: IUseBuildingItemProps) => {
  const [historyPage, setHistoryPage] = useState(1);
  const {
    isFormClean,
    handleClear,
    handleCloseTrigger,
    tabIndex,
    handleTriggerChangeTab,
    triggerClose,
  } = useContext(AdminPanelDrawerContext);

  const building = useBuildingQuery({
    building_id: id,
  });

  const buildingHistory = useBuildingHistoryQuery({
    building_id: id,
    page: historyPage,
    limit: 100,
    enabled: tabIndex === historyTabIndex,
  });

  useEffect(() => {
    if (isFormClean && triggerClose) {
      handleClose();
      handleClear();
    }
  }, [isFormClean, triggerClose]);

  return {
    building,
    tabIndex,
    handleTriggerChangeTab,
    buildingHistory: buildingHistory.data,
    historyPage,
    setHistoryPage,
    handleCloseTrigger,
    historyTabIndex,
  };
};
